import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import offerV2PreviewReducer from '../reducers/offerV2PreviewReducer';

const configureStore = (railsProps) => (
  createStore(offerV2PreviewReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
